/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// ===================== CheckoutChamp Helpers =====================
(function(){
	if (window.CC_helpers_loaded) return; // Prevent double inclusion
	window.CC_helpers_loaded = true;

	function cfg(){ return window.checkoutChamp || {}; }

	function detectPathLanguage(){
		try{
			var seg = window.location && window.location.pathname ? window.location.pathname.split('/').filter(Boolean) : [];
			if(seg.length && /^[a-z]{2}(?:-[a-z]{2})?$/i.test(seg[0])){
				return seg[0];
			}
		}catch(_e){}
		return '';
	}

	function currentLanguage(){
		try{
			if(window.Shopify && Shopify.locale){ return String(Shopify.locale).toLowerCase(); }
		}catch(_e){}
		try{
			var htmlLang = document.documentElement && document.documentElement.lang;
			if(htmlLang){ return String(htmlLang).toLowerCase(); }
		}catch(_e){}
		var pathLang = detectPathLanguage();
		if(pathLang){ return pathLang.toLowerCase(); }
		try{
			var accept = navigator.language || (navigator.languages && navigator.languages[0]);
			if(accept){ return String(accept).split('-')[0].toLowerCase(); }
		}catch(_e){}
		return 'fr';
	}

	function endpoint(pathKey){
		var c = cfg();
		if(!c.endpoints) return '';
		var base = c.endpoints.base || '';
		var slug = c.endpoints[pathKey] || '';
		return base.replace(/\/$/,'') + '/' + slug.replace(/^\//,'');
	}

	function isCrossOrigin(u){
		try{ var url = new URL(u, location.href); return url.origin !== location.origin; } catch(e){ return true; }
	}

	// Export parity: get Shopify cart id from cookie when needed
	function getCartCookie(name){
		try{
			var m = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
			return m ? m[2] : null;
		}catch(_e){ return null; }
	}
	function getCartIdFromCookie(){
		var raw = getCartCookie('cart');
		if(!raw) return '';
		var id = raw.split('?')[0] || raw;
		try{ return decodeURIComponent(id); }catch(_e){ return id; }
	}

	function isDiscountActive(){
		try{
			return sessionStorage.getItem('subscription_active') === '1' || sessionStorage.getItem('subscription_discount') === 'true';
		}catch(_e){ return false; }
	}

	function getSubscriptionVariantId(){
		try{
			var sub = cfg().subscription || {};
			if(sub && sub.variantId){ return String(sub.variantId); }
		}catch(_e){}
		return null;
	}

	let normalizeSubInFlight = false;
	let normalizeSubTimer = null;

	function scheduleSubscriptionNormalization(delay){
		if(normalizeSubTimer){ clearTimeout(normalizeSubTimer); }
		normalizeSubTimer = setTimeout(function(){
			normalizeSubscriptionQuantity('scheduled');
		}, delay || 50);
	}

	window.scheduleSubscriptionNormalization = scheduleSubscriptionNormalization;

	function requestSubscriptionNormalization(delay){
		var normalizeFn = window.scheduleSubscriptionNormalization;
		if(typeof normalizeFn === 'function'){
			normalizeFn(delay);
		}
	}
	window.requestSubscriptionNormalization = requestSubscriptionNormalization;

	async function normalizeSubscriptionQuantity(reason){
		if(normalizeSubInFlight) return;
		const variantId = getSubscriptionVariantId();
		if(!variantId) return;
		try{
			normalizeSubInFlight = true;
			const cart = await fetch('/cart.js',{cache:'no-store', credentials:'same-origin'}).then(r=>r.json()).catch(()=>null);
			if(!cart || !Array.isArray(cart.items)) return;
			const subLine = cart.items.find(function(it){
				return String(it.variant_id) === variantId || String(it.id) === variantId;
			});
			if(subLine && subLine.quantity > 1){
				const payload = { updates: {} };
				payload.updates[variantId] = 1;
				await fetch('/cart/update.js',{
					method:'POST',
					headers:{'Content-Type':'application/json','Accept':'application/json'},
					body: JSON.stringify(payload)
				}).catch(()=>{});
				document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
			}
		} catch(_e) {

		} finally {
			normalizeSubInFlight = false;
		}
	}

	try{
		if(typeof window.fetch === 'function' && !window.__ccxSubFetchPatched){
			window.__ccxSubFetchPatched = true;
			const nativeFetch = window.fetch;
			window.fetch = function(resource, init){
				const response = nativeFetch.apply(this, arguments);
				try{
					let url = '';
					if(typeof resource === 'string'){ url = resource; }
					else if(resource && typeof resource.url === 'string'){ url = resource.url; }
					if(/\/cart\/(add|update|change)\.js/i.test(url)){
						response.then(function(){ requestSubscriptionNormalization(120); })
							.catch(function(){ requestSubscriptionNormalization(200); });
					}
				}catch(_e){}
				return response;
			};
		}
	}catch(_e){}

	// -------- Parameter Aliasing (diversification) --------
	// To avoid exposing the full alias lists publicly, use a single non-canonical alias per key by default.
	// You can override any key via window.checkoutChamp.aliasMap = { apiKey:'X-Access-Key', email:'adresseEmail', ... }
	const DEFAULT_ALIAS_MAP = {
		apiKey: 'X-Access-Key',
		email: 'adresseEmail',
		domaine: 'domain_name',
		customerId: 'client_id',
		orderId: 'order_ref',
		timestamp: 'request_time',
		footprint: 'trackingId',
		language: 'lang'
	};
	function aliasKey(key){
		try{ var m = (cfg().aliasMap || {}); if(Object.prototype.hasOwnProperty.call(m, key) && m[key]) return m[key]; }catch(_e){}
		return Object.prototype.hasOwnProperty.call(DEFAULT_ALIAS_MAP, key) ? DEFAULT_ALIAS_MAP[key] : key;
	}

	function aliasPayload(obj){
		const out = {};
		Object.keys(obj||{}).forEach(k=>{
			const ak = aliasKey(k);
			if(ak !== k) out[ak] = obj[k]; else out[k] = obj[k];
		});
		return out;
	}

	// Build a payload containing BOTH canonical and aliased keys (for maximum server compatibility)
	function withAliases(base){
		const out = {};
		Object.keys(base||{}).forEach(function(k){
			const v = base[k];
			const ak = aliasKey(k);
			out[k] = v;
			if(ak && ak !== k){ out[ak] = v; }
		});
		return out;
	}

	async function fetchCartMeta(){
		const res = await fetch('/cart?view=meta-data.json', {credentials:'same-origin'});
		if(!res.ok) throw new Error('Cart meta fetch failed');
		return res.json();
	}

	function buildProductsParams(meta){
		if(!meta || !Array.isArray(meta.meta_product_id_array)) return '';
		const items = meta.meta_product_id_array;
		const cfgSub = cfg().subscription || {};
		const subVariantId = cfgSub && cfgSub.variantId ? String(cfgSub.variantId) : null;
		const subProductId = cfgSub && cfgSub.productId ? String(cfgSub.productId) : null;
		const hasSubProduct = items.some(it => {
			let pid, vid; try{ if(typeof it.id==='string' && it.id.indexOf('.')>-1){ [pid,vid] = it.id.split('.'); } else { pid = it.id; vid = null; } }catch(_e){}
			return !!(it.is_subscription || (vid && subVariantId && String(vid)===subVariantId) || (pid && subProductId && String(pid)===subProductId));
		});
		const discountActive = hasSubProduct || isDiscountActive();
		const shipCents = (cfg().subscription && typeof cfg().subscription.shipPriceCents === 'number') ? cfg().subscription.shipPriceCents : 0;
		let parts = [];
		let shippingAssigned = false;
		items.forEach(function(item, idx){
			const Index = idx + 1; // 1-based per spec example
			let productId = item.id.indexOf('.') > -1 ? item.id.split('.')[0] : item.id;
			let variantId = item.id.indexOf('.') > -1 ? item.id.split('.')[1] : null;
			let isSub = !!(item.is_subscription || (subVariantId && String(variantId)===subVariantId) || (subProductId && String(productId)===subProductId));
			// Price rules: send PER-UNIT price; apply 50% by flooring cents to match checkout UI (49.99 vs 50.00 cases)
			// item.price is unit price in cents
			let priceCents = isSub ? 0 : (discountActive ? Math.floor(item.price / 2) : item.price);
			let price = priceCents / 100;
			let shipPrice;
			if (discountActive) {
				shipPrice = 0; // shipping free when subscription present
			} else {
				// assign configured shipping amount once to the first product only
				if(!shippingAssigned && shipCents > 0){ shipPrice = shipCents/100; shippingAssigned = true; }
				else { shipPrice = 0; }
			}
			parts.push(
				`&product${Index}_id=${encodeURIComponent(productId)}` +
				(variantId ? `&variant${Index}_id=${encodeURIComponent(variantId)}` : '') +
				`&product${Index}_qty=${encodeURIComponent(item.quantity)}` +
				`&product${Index}_price=${encodeURIComponent(price.toFixed(2))}` +
				`&product${Index}_shipPrice=${encodeURIComponent(shipPrice.toFixed(2))}`
			);
		});
		return parts.join('');
	}

	// Fallback: build products params directly from /cart.js when meta view is unavailable
	function buildProductsParamsFromCart(cart){
		try{
			if(!cart || !Array.isArray(cart.items)) return '';
			const items = cart.items;
			const cfgSub = cfg().subscription || {};
			const subVariantId = cfgSub && cfgSub.variantId ? String(cfgSub.variantId) : null;
			const subProductId = cfgSub && cfgSub.productId ? String(cfgSub.productId) : null;
			const hasSubProduct = items.some(li => !!(li.selling_plan_allocation || (subVariantId && String(li.variant_id)===subVariantId) || (subProductId && String(li.product_id)===subProductId) || (typeof li.final_line_price==='number' && li.final_line_price===0)));
			const discountActive = hasSubProduct || isDiscountActive();
			const shipCents = (cfg().subscription && typeof cfg().subscription.shipPriceCents === 'number') ? cfg().subscription.shipPriceCents : 0;
			let parts=[];
			let shippingAssigned = false;
			items.forEach(function(li, idx){
				const Index = idx + 1;
				const productId = li.product_id || (li.product && li.product.id) || li.id;
				const variantId = li.variant_id || null;
				const qty = li.quantity || 1;
				// Heuristic: treat subscription item lines if price is 0 and/or selling plan present
				const isSub = !!(li.selling_plan_allocation || (subVariantId && String(variantId)===subVariantId) || (subProductId && String(productId)===subProductId) || (typeof li.final_line_price==='number' && li.final_line_price===0));
				const unitPriceCents = (typeof li.price === 'number') ? li.price : (typeof li.final_price==='number' ? li.final_price : 0);
				let priceCents = isSub ? 0 : (discountActive ? Math.floor(unitPriceCents / 2) : unitPriceCents);
				let price = priceCents / 100;
				let shipPrice;
				if (discountActive) { shipPrice = 0; }
				else {
					if(!shippingAssigned && shipCents > 0){ shipPrice = shipCents/100; shippingAssigned = true; }
					else { shipPrice = 0; }
				}
				parts.push(
					`&product${Index}_id=${encodeURIComponent(productId)}` +
					(variantId ? `&variant${Index}_id=${encodeURIComponent(variantId)}` : '') +
					`&product${Index}_qty=${encodeURIComponent(qty)}` +
					`&product${Index}_price=${encodeURIComponent(price.toFixed(2))}` +
					`&product${Index}_shipPrice=${encodeURIComponent(shipPrice.toFixed(2))}`
				);
			});
			return parts.join('');
		}catch(_e){ return ''; }
	}

	// Compute checkout total (in cents) mirroring the checkout page logic
	async function computeCheckoutTotalCents(){
		// Compute total based on the same per-unit rounding and shipping rules used in products payload
		try{
			await refreshCCProductsParams();
			const params = String(window.ccProductsParams||'');
			if(!params) return 0;
			let totalCents = 0;
			// Parse pairs like &productN_qty=QTY, &productN_price=PP.pp, &productN_shipPrice=SS.ss
			const qtyRe = /[&?]product(\d+)_qty=([^&]*)/g;
			const priceMap = new Map();
			const qtyMap = new Map();
			const shipMap = new Map();
			let m;
			while((m = qtyRe.exec(params))){ qtyMap.set(m[1], decodeURIComponent(m[2])); }
			const priceRe = /[&?]product(\d+)_price=([^&]*)/g;
			while((m = priceRe.exec(params))){ priceMap.set(m[1], decodeURIComponent(m[2])); }
			const shipRe = /[&?]product(\d+)_shipPrice=([^&]*)/g;
			while((m = shipRe.exec(params))){ shipMap.set(m[1], decodeURIComponent(m[2])); }
			priceMap.forEach((pStr, idx)=>{
				const qty = Number(qtyMap.get(idx)||'1') || 1;
				const priceCents = Math.round((Number(pStr)||0) * 100);
				const shipCents = Math.round((Number(shipMap.get(idx)||'0')||0) * 100);
				totalCents += (priceCents * qty) + shipCents;
			});
			return totalCents;
		}catch(_e){ return 0; }
	}

	// Compute original total (in cents) as if no subscription benefits applied (no 50% discount, shipping charged once)
	async function computeOriginalTotalCents(){
		try{
			const cfgSub = cfg().subscription || {};
			const shipCentsCfg = (typeof cfgSub.shipPriceCents==='number') ? cfgSub.shipPriceCents : 0;
			const cart = await readCart(); if(!cart || !Array.isArray(cart.items)) return 0;
			let subtotal = 0;
			(cart.items||[]).forEach(li => {
				const qty = li.quantity || 1;
				const unitPriceCents = (typeof li.price === 'number') ? li.price : (typeof li.final_price==='number' ? li.final_price : 0);
				subtotal += (unitPriceCents * qty);
			});
			const total = subtotal + (shipCentsCfg || 0);
			return total;
		}catch(_e){ return 0; }
	}

	async function readCart(){
		try{ const r = await fetch('/cart.js', {credentials:'same-origin', cache:'no-store'}); return await r.json(); }catch(_e){ return null; }
	}

	async function refreshCCProductsParams(){
		try {
			let params = '';
			try{
				const meta = await fetchCartMeta();
				window.ccProductsMeta = meta; params = buildProductsParams(meta);
				// Validate coverage: if meta view omits some items, rebuild from /cart.js for completeness
				try{
					const cart = await readCart();
					const cartCount = (cart && Array.isArray(cart.items)) ? cart.items.length : 0;
					const metaCount = (meta && Array.isArray(meta.meta_product_id_array)) ? meta.meta_product_id_array.length : 0;
					if(cartCount && metaCount && metaCount < cartCount){
						params = buildProductsParamsFromCart(cart);
					}
				} catch(_e2){}
			}catch(e){
				// Fallback to /cart.js
				const cart = await readCart();
				params = buildProductsParamsFromCart(cart);
			}
			window.ccProductsParams = params || '';
			document.documentElement.dispatchEvent(new CustomEvent('cc:products-updated', {bubbles:true, detail:{params: window.ccProductsParams}}));
		} catch(e){ console.warn('[CheckoutChamp] Unable to refresh products meta', e); }
	}

	// Abandoned cart partial (light implementation)
	async function sendPartial(data){
		try {
			const url = endpoint('partial');
			if(!url || url === '/' || /^(https?:)?\/\/?$/.test(url)) { return; } // Guard: avoid root POST
			// Do not skip cross-origin here: partials should reach the configured API; rely on server CORS
			// Gather cart and identifiers once
			let cart = null;
			try { cart = await readCart(); } catch(_e) { cart = null; }
			let cartId = getCartIdFromCookie();
			if(!cartId){ try{ cartId = (cart && (cart.token || cart.id || cart.cart_token)) || ''; }catch(_e){} }

			// Helper readers
			function getHidden(name){ try{ var el = document.querySelector('input[name="'+name+'"]'); if(el && el.value) return String(el.value).trim(); }catch(_e){} return ''; }
			function pick(){ for(var i=0;i<arguments.length;i++){ var v = arguments[i]; if(v!==undefined && v!==null && String(v).trim()!=='') return String(v).trim(); } return ''; }
			function normCountry(raw){
				try{
					var r = String(raw||'').trim();
					if(!r || r==='---' || r==='--') return 'FR';
					var cl = r.toLowerCase();
					var m = { 'france':'FR','fr':'FR','belgique':'BE','belgium':'BE','be':'BE','luxembourg':'LU','lu':'LU','suisse':'CH','switzerland':'CH','ch':'CH','royaume-uni':'GB','united kingdom':'GB','uk':'GB','gb':'GB' };
					return m[cl] || (r.length===2 ? r.toUpperCase() : 'FR');
				}catch(_e){ return 'FR'; }
			}
			function pageSlug(){ try{ var seg = location.pathname.split('/').filter(Boolean); return seg[seg.length-1]||'checkout'; }catch(_e){ return 'checkout'; } }

			const attrs = (cart && cart.attributes) || {};
			// Contact info
			let email = pick(getHidden('ccx-clientEmail'), attrs.clientEmail, attrs.emailAddress, (cart && cart.email), (cart && cart.buyer_identity && cart.buyer_identity.customer_email));
			if(!email){ try{ if(window.Shopify && Shopify.customer && Shopify.customer.email){ email = String(Shopify.customer.email).trim(); } }catch(_e){} }
			let phone = pick(getHidden('ccx-clientPhone'), attrs.clientPhone, attrs.phone, (cart && cart.phone));
			// Names
			let firstName = pick(getHidden('ccx-clientFirstName'), attrs.clientFirstName, attrs.shippingFirstName, (cart && cart.shipping_address && cart.shipping_address.first_name));
			let lastName  = pick(getHidden('ccx-clientLastName'),  attrs.clientLastName,  attrs.shippingLastName,  (cart && cart.shipping_address && cart.shipping_address.last_name));
			// Address
			let address1 = pick(getHidden('ccx-deliveryAddress1'), attrs.deliveryAddress1, attrs.shippingAddress1, (cart && cart.shipping_address && cart.shipping_address.address1));
			let address2 = pick(getHidden('ccx-deliveryAddress2'), attrs.deliveryAddress2, attrs.shippingAddress2, (cart && cart.shipping_address && cart.shipping_address.address2));
			let postalCode = pick(getHidden('ccx-zipCode'), attrs.zipCode, attrs.shippingPostalCode, (cart && cart.shipping_address && cart.shipping_address.zip));
			let city = pick(getHidden('ccx-deliveryCity'), attrs.deliveryCity, attrs.shippingCity, (cart && cart.shipping_address && cart.shipping_address.city));
			let countryRaw = pick(getHidden('ccx-deliveryCountry'), attrs.deliveryCountry, attrs.shippingCountry, (cart && cart.shipping_address && cart.shipping_address.country_code));
			let country = normCountry(countryRaw);

			// Shipping mirrors billing for now
			let shipFirstName = firstName, shipLastName = lastName;
			let shipAddress1 = address1, shipAddress2 = address2, shipPostalCode = postalCode, shipCity = city, shipCountry = country;

			// UTM/customs & slugs
			let slug = pageSlug();
			let custom3 = (cfg().slugs && cfg().slugs.thankYou) ? cfg().slugs.thankYou : 'thank-you';
			let urlParams; try{ urlParams = new URLSearchParams(window.location.search||''); }catch(_e){ urlParams = null; }
			const urlCampaign = urlParams ? (urlParams.get('campaignId') || urlParams.get('campaignID') || '') : '';
			const urlForceMerchant = urlParams ? (urlParams.get('forceMerchantId') || urlParams.get('forceMerchantID') || '') : '';
			const defaultCampaign = cfg().campaignId || '';
			const originalCampaignId = urlCampaign || (attrs && attrs.originalCampaignId) || defaultCampaign;
			const forceMerchantId = urlForceMerchant || (attrs && attrs.forceMerchantId) || '';

			// Ensure cart attributes stay aligned once resolved so reloads remain stable
			if(originalCampaignId && (attrs.originalCampaignId !== originalCampaignId || (forceMerchantId && attrs.forceMerchantId !== forceMerchantId))){
				try{
					await fetch('/cart/update.js',{
						method:'POST',
						headers:{'Content-Type':'application/json','Accept':'application/json'},
						body: JSON.stringify({ attributes: { originalCampaignId: originalCampaignId, forceMerchantId: forceMerchantId } })
					});
				}catch(_e){}
			}

			// Build strictly the documented Partial payload only
			const core = {
				apiKey: cfg().apiKeyHashed,
				timestamp: Date.now(),
				language: currentLanguage(),
				products: window.ccProductsParams || '',
				cartId: cartId,
				firstName: firstName,
				lastName: lastName,
				address1: address1,
				address2: address2,
				postalCode: postalCode,
				city: city,
				country: country,
				emailAddress: email,
				phoneNumber: phone,
				ipAddress: '',
				shipFirstName: shipFirstName,
				shipLastName: shipLastName,
				shipAddress1: shipAddress1,
				shipAddress2: shipAddress2,
				shipPostalCode: shipPostalCode,
				shipCity: shipCity,
				shipCountry: shipCountry,
				billShipSame: '1',
				custom1: window.location.hostname,
				custom2: slug,
				custom3: custom3,
				custom4: '',
				custom5: '',
				campaignId: defaultCampaign,
				originalCampaignId: originalCampaignId,
				checkoutUrl: window.location.href
			};
			const merged = Object.assign({}, core, data || {});
			const body = merged;
			const controller = new AbortController();
			const t = setTimeout(()=>controller.abort(), 7000);
			await fetch(url, {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body), signal: controller.signal})
				.catch(err=>{ if(err.name!=='AbortError') console.debug('[CheckoutChamp] partial send skipped', err); });
			clearTimeout(t);
		} catch(e){ console.debug('[CheckoutChamp] partial send skipped', e); }
	}

	// Cancel subscription helper (also used inside section but exposed for reuse)
	// Accepts either a string email or an object { email, customerId?, orderId?, ... }
	async function cancelSubscription(emailOrParams){
		const url = endpoint('cancelSubscription');
		if(!url || url==='/' ) return { success:false, error:'Missing endpoint'}; 
		try {
			var params = (typeof emailOrParams === 'string') ? { email: emailOrParams } : (emailOrParams || {});
			// Normalize email/emailAddress duplication for stricter APIs
			if(params.email && !params.emailAddress){ params.emailAddress = params.email; }
			if(params.emailAddress && !params.email){ params.email = params.emailAddress; }
			// Core fields
			const core = {
				email: params.email,
				emailAddress: params.emailAddress,
				apiKey: cfg().apiKeyHashed,
				timestamp: Date.now(),
				domaine: location.hostname,
				footprint: Math.random().toString(36).substring(2),
				language: currentLanguage()
			};
			// Merge optional identifiers (customerId, orderId, etc.)
			const merged = Object.assign({}, params, core);
			// Include both canonical and aliased keys to maximize compatibility
			const body = withAliases(merged);
			const res = await fetch(url,{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)});
			return res.json();
		}catch(err){ console.debug('[CheckoutChamp] cancelSubscription skipped', err); return { success:false }; }
	}

	// In-memory caches for subscription status and rate limit coordination
	const SUB_CACHE = new Map(); // key: email -> {active:boolean, expires:number}
	const SUB_IN_FLIGHT = new Map(); // key: email -> Promise<boolean>
	const SUB_COOLDOWN = new Map(); // key: email -> number (epoch ms)

	function nowMs(){ return Date.now(); }
	function readJSONSafe(key){ try{ const s=sessionStorage.getItem(key); return s?JSON.parse(s):null; }catch(_e){ return null; }}
	function writeJSONSafe(key,val){ try{ sessionStorage.setItem(key, JSON.stringify(val)); }catch(_e){} }

	function readRateLimitUntil(){
		try{ const v = sessionStorage.getItem('cc_sub_rl_until'); return v?parseInt(v,10):0; }catch(_e){ return 0; }
	}
	function writeRateLimitUntil(ts){ try{ sessionStorage.setItem('cc_sub_rl_until', String(ts||0)); }catch(_e){} }

	function setCachedStatus(email, active, ttlMs){
		const lc = (email||'').trim().toLowerCase(); if(!lc) return;
		const rec = { active: !!active, expires: nowMs() + (ttlMs|| (10*60*1000)) };
		SUB_CACHE.set(lc, rec);
		writeJSONSafe('cc_sub_status:'+lc, rec);
		try{
			if(active){
				sessionStorage.setItem('subscription_active','1');
				sessionStorage.setItem('subscription_discount','true');
				// notify listeners
				document.documentElement.dispatchEvent(new CustomEvent('cc:subscription-status', {bubbles:true, detail:{active:true, email:lc}}));
			} else {
				sessionStorage.setItem('subscription_active','0');
				document.documentElement.dispatchEvent(new CustomEvent('cc:subscription-status', {bubbles:true, detail:{active:false, email:lc}}));
			}
		}catch(_e){}
	}
	function getCachedStatus(email){
		const lc = (email||'').trim().toLowerCase(); if(!lc) return null;
		const recMem = SUB_CACHE.get(lc);
		if(recMem && recMem.expires > nowMs()) return recMem;
		const recSS = readJSONSafe('cc_sub_status:'+lc);
		if(recSS && recSS.expires && recSS.expires > nowMs()){ SUB_CACHE.set(lc, recSS); return recSS; }
		return null;
	}

	function invalidateSubscriptionCache(email){
		const lc = (email||'').trim().toLowerCase(); if(!lc) return;
		SUB_CACHE.delete(lc);
		SUB_IN_FLIGHT.delete(lc);
		SUB_COOLDOWN.delete(lc);
		try{ sessionStorage.removeItem('cc_sub_status:'+lc); }catch(_e){}
	}

	// Subscription check with caching, de-dup, and 429 handling
	async function hasActiveSubscription(email){
		const url = endpoint('subscriptionCheck');
		if(!url || url==='/' ) return false;
		const lc = (email||'').trim().toLowerCase();
		if(!lc){
			// Fall back to global session flag when email is missing
			return (sessionStorage.getItem('subscription_active') === '1');
		}

		// If we are under a server-declared cooldown, avoid calling
		const rlUntil = Math.max(readRateLimitUntil(), SUB_COOLDOWN.get(lc)||0);
		if(rlUntil && rlUntil > nowMs()){
			const cached = getCachedStatus(lc);
			return cached ? !!cached.active : (sessionStorage.getItem('subscription_active')==='1');
		}

		// Use valid cache if present
		const cached = getCachedStatus(lc);
		if(cached) return !!cached.active;

		// De-duplicate concurrent calls
		if(SUB_IN_FLIGHT.has(lc)) return SUB_IN_FLIGHT.get(lc);

		// Include both email and emailAddress for stricter APIs
		const base = {
			email: lc,
			emailAddress: lc,
			apiKey: cfg().apiKeyHashed,
			timestamp: Date.now(),
			domaine: location.hostname,
			footprint: Math.random().toString(36).substring(2),
			language: currentLanguage()
		};
		const body = withAliases(base);

		const p = (async ()=>{
			try{
				const controller = new AbortController();
				const to = setTimeout(()=>controller.abort(), 8000);
				const res = await fetch(url,{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body), signal: controller.signal});
				clearTimeout(to);
				// Handle 429 gracefully with cooldown
				if(res.status === 429){
					let retrySec = 0;
					const ra = res.headers.get && res.headers.get('Retry-After');
					if(ra){ const n = parseInt(ra,10); if(!isNaN(n)) retrySec = Math.min(Math.max(n, 15), 600); }
					if(!retrySec) retrySec = 120; // default 2 minutes
					const until = nowMs() + retrySec*1000;
					SUB_COOLDOWN.set(lc, until); writeRateLimitUntil(until);
					const c = getCachedStatus(lc);
					return c ? !!c.active : (sessionStorage.getItem('subscription_active')==='1');
				}
				// Non-OK other statuses
				if(!res.ok){
					const c = getCachedStatus(lc);
					return c ? !!c.active : false;
				}
				const data = await res.json();
				const active = !!(data && data.success === true);
				setCachedStatus(lc, active);
				return active;
			}catch(err){
				// Network error or aborted: prefer cached or session flag
				const c = getCachedStatus(lc);
				if(c) return !!c.active;
				return (sessionStorage.getItem('subscription_active')==='1');
			} finally {
				SUB_IN_FLIGHT.delete(lc);
			}
		})();
		SUB_IN_FLIGHT.set(lc, p);
		return p;
	}

	// -------- Account, Subscription Action, Code Generation, Order helpers --------
	async function fetchAccount(params){
		const url = endpoint('account');
		const p = Object.assign({ apiKey: cfg().apiKeyHashed, timestamp: Date.now(), language: currentLanguage() }, params);
		// Normalize email fields
		if(p.email && !p.emailAddress){ p.emailAddress = p.email; }
		if(p.emailAddress && !p.email){ p.email = p.emailAddress; }
		const body = withAliases(p);
		const res = await fetch(url,{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)});
		return res.json();
	}

	async function subscriptionAction(params){ // { email, action: 'cancel'|'activate', purchaseId, customerId }
		const url = endpoint('subscriptionAction');
		const p = Object.assign({ apiKey: cfg().apiKeyHashed, timestamp: Date.now(), language: currentLanguage() }, params);
		// Normalize email fields
		if(p.email && !p.emailAddress){ p.emailAddress = p.email; }
		if(p.emailAddress && !p.email){ p.email = p.emailAddress; }
		const body = withAliases(p);
		const res = await fetch(url,{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)});
		return res.json();
	}

	async function generateCode(params){ // { email, domaine, customerId|orderId }
		const url = endpoint('codeGeneration');
		const core = { apiKey: cfg().apiKeyHashed, timestamp: Date.now(), domaine: location.hostname, language: currentLanguage() };
		const p = Object.assign({}, core, params);
		// Normalize email fields
		if(p.email && !p.emailAddress){ p.emailAddress = p.email; }
		if(p.emailAddress && !p.email){ p.email = p.emailAddress; }
		const body = withAliases(p);
		const res = await fetch(url,{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)});
		return res.json();
	}

	async function sendOrder(params){
		const url = endpoint('payment');
		// Ensure products and cart token are available
		// Always refresh products just before sending to capture latest discount/subscription state
		let productsStr = '';
		try { await refreshCCProductsParams(); productsStr = window.ccProductsParams || ''; } catch(_e) { productsStr = window.ccProductsParams || ''; }
		let ensuredCartId = params && params.cartId;
		if(!ensuredCartId){
			// Try cookie first (matches export), then /cart.js fallback
			ensuredCartId = getCartIdFromCookie();
			if(!ensuredCartId){
				const cart = await readCart();
				ensuredCartId = cart && (cart.token || cart.id || cart.cart_token) || '';
			}
		}
		// Build body mirroring export: params can add fields, but required fields are ensured here
		const merged = Object.assign({}, params || {});
		if(!merged.cartId){ merged.cartId = ensuredCartId; }
		// Provide duplicate cart id fields for stricter APIs expecting cart_id/cartToken
		if(!merged.cart_id){ merged.cart_id = merged.cartId; }
		if(!merged.cartToken){ merged.cartToken = merged.cartId; }
		// Normalize email fields across possible inputs
		// Prefer explicit params.email/emailAddress, else derive from clientEmail and additional fallbacks
		var emailCandidate = merged.email || merged.emailAddress || merged.clientEmail || '';
		if(!emailCandidate){
			try{ emailCandidate = (sessionStorage.getItem('customer_email')||'').trim(); }catch(_e){}
		}
		if(!emailCandidate){
			try{ if(window.Shopify && Shopify.customer && Shopify.customer.email){ emailCandidate = String(Shopify.customer.email||'').trim(); } }catch(_e){}
		}
		if(!emailCandidate){
			try{ const cart = await readCart(); emailCandidate = (cart && cart.attributes && cart.attributes.clientEmail) || (cart && cart.buyer_identity && cart.buyer_identity.customer_email) || cart && cart.email || ''; }catch(_e){}
		}
		if(!merged.email && emailCandidate){ merged.email = emailCandidate; }
		if(!merged.emailAddress && (merged.email || emailCandidate)){ merged.emailAddress = merged.email || emailCandidate; }
		merged.apiKey = cfg().apiKeyHashed;
		merged.timestamp = Date.now();
		merged.products = productsStr;
		merged.domaine = location.hostname;
		merged.language = currentLanguage();
		// Include a numeric total matching the checkout display for server use
		try{
			const payableCents = await computeCheckoutTotalCents();
			const originalCents = await computeOriginalTotalCents();
			if(!merged.totalAmount){ merged.totalAmount = (originalCents/100).toFixed(2); }
			if(!merged.amount){ merged.amount = merged.totalAmount; }
			if(!merged.chargeTotal){ merged.chargeTotal = (payableCents/100).toFixed(2); }
		}catch(_e){}
		// Include both canonical and aliased keys for maximum compatibility
		const body = withAliases(merged);
		try{
			const res = await fetch(url,{method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)});
			return res.json();
		}catch(err){
			// Surface a clearer CORS hint for client code
			const msg = (err && err.message) || '';
			if(isCrossOrigin(url)){
				throw new Error('CORS_BLOCKED: Impossible de contacter le service de paiement depuis ce domaine. Configurez un proxy sur votre domaine ou demandez l\'ajout des en-têtes CORS côté API.');
			}
			throw err;
		}
	}

	// Public API
	window.CheckoutChampLib = {
		refreshCCProductsParams: refreshCCProductsParams,
		buildProductsParams: buildProductsParams,
		fetchCartMeta: fetchCartMeta,
		sendPartial: sendPartial,
		cancelSubscription: cancelSubscription,
		invalidateSubscriptionCache: invalidateSubscriptionCache,
		hasActiveSubscription: hasActiveSubscription,
		fetchAccount: fetchAccount,
		subscriptionAction: subscriptionAction,
		generateCode: generateCode,
		sendOrder: sendOrder,
		computeCheckoutTotalCents: computeCheckoutTotalCents,
		computeOriginalTotalCents: computeOriginalTotalCents,
		currentLanguage: currentLanguage
	};

	// Auto refresh on cart events
	document.addEventListener('product:added', refreshCCProductsParams);
	document.addEventListener('cart:refresh', refreshCCProductsParams);

	// Initial attempt after load
	if (document.readyState === 'complete' || document.readyState === 'interactive') {
		refreshCCProductsParams();
	} else {
		document.addEventListener('DOMContentLoaded', refreshCCProductsParams);
	}

	// After updating products, optionally send partial after small debounce
	let partialTimer;
	function isCheckoutPage(){
		try{
			return /\/pages\/checkout/i.test(window.location.pathname || '') || /\/checkout$/i.test(window.location.pathname || '');
		}catch(_e){ return false; }
	}
	document.addEventListener('cc:products-updated', function(){
		clearTimeout(partialTimer);
		partialTimer = setTimeout(function(){
			// Only send partial once on the checkout page; skip on other pages
			if (!isCheckoutPage()) return;
			if ((window.ccProductsMeta && window.ccProductsMeta.meta_product_id_array || []).length > 0){
				sendPartial();
			}
		}, 1200);
	});

	// If subscription status changes during the session, recompute products params so discounts/shipping carry through
	document.documentElement.addEventListener('cc:subscription-status', function(){
		try { refreshCCProductsParams(); } catch(_e) {}
	});

	/* Suppress noisy 401/404 console errors from private token pings or missing endpoints without hiding real errors */
	(function(){
		var ORIG_ERROR = console.error; var ORIG_WARN = console.warn;
		function isNoisy(args){
			try { var s = Array.prototype.join.call(args,' '); return /sf_private_access_tokens|401 \(Unauthorized\)/.test(s) || /partial send skipped/.test(s); } catch(e){ return false; }
		}
		console.error = function(){ if(isNoisy(arguments)) return; ORIG_ERROR.apply(console, arguments); };
		console.warn = function(){ if(isNoisy(arguments)) return; ORIG_WARN.apply(console, arguments); };
	})();
})();

// Bootstrap subscription flag from cache on load for price replacement
(function(){
	try{
		var sub = sessionStorage.getItem('subscription_active');
		if(sub === '1' || sub === '0'){ return; }
		// Only trust cache that matches the current customer email
		var email = '';
		try{ if(window.Shopify && Shopify.customer && Shopify.customer.email){ email = String(Shopify.customer.email||'').trim().toLowerCase(); } }catch(_e1){}
		if(email){
			var recStr = sessionStorage.getItem('cc_sub_status:'+email);
			if(recStr){
				try{
					var rec = JSON.parse(recStr||'null');
					if(rec && rec.active && (!rec.expires || rec.expires > Date.now())){
						sessionStorage.setItem('subscription_active','1');
						sessionStorage.setItem('subscription_discount','true');
						document.documentElement.dispatchEvent(new CustomEvent('cc:subscription-status',{bubbles:true, detail:{active:true, email:email}}));
					}
				} catch(_e2){}
			}
		}
	}catch(_e){}
})();

	// Proactively ensure subscription flag by checking with API if we have an email
	(function(){
		async function getCartEmail(){
			try{ const r = await fetch('/cart.js', {credentials:'same-origin', cache:'no-store'}); const c = await r.json();
				// common locations: attributes.clientEmail (new), buyer_identity?.customer_email, cart.email
				let fromCart = (c && c.attributes && c.attributes.clientEmail) || (c && c.buyer_identity && c.buyer_identity.customer_email) || c.email || '';
				if(fromCart) return fromCart;
				// Fallback to Shopify customer when logged in
				try{ if(window.Shopify && Shopify.customer && Shopify.customer.email){ return Shopify.customer.email; } }catch(_e){}
				return '';
			}catch(_e){
				try{ if(window.Shopify && Shopify.customer && Shopify.customer.email){ return Shopify.customer.email; } }catch(_e2){}
				return '';
			}
		}
		(async function(){
			try{
				const now = Date.now();
				const last = parseInt(sessionStorage.getItem('cc_last_sub_check')||'0',10) || 0;
				if(now - last < 5*60*1000) return; // 5 min window
				if(sessionStorage.getItem('subscription_active')==='1') return;
				let email = sessionStorage.getItem('customer_email') || '';
				if(!email){ email = await getCartEmail(); }
						if(email){
					sessionStorage.setItem('cc_last_sub_check', String(now));
							try{ await window.CheckoutChampLib.hasActiveSubscription(email); }catch(_e){}
				}
			}catch(_e){}
		})();
	})();

// ===================== Policy Pages TOC / Anchors =====================
(function(){
	if (window.PolicyTOCInitialized) return; window.PolicyTOCInitialized = true;

	function slugify(str){
		return (str||'')
			.toString()
			.normalize('NFD').replace(/\p{Diacritic}/gu,'')
			.toLowerCase()
			.replace(/[^a-z0-9]+/g,'-')
			.replace(/^-+|-+$/g,'')
			.substring(0,80);
	}

		function buildTOC(container){
		const rootId = container.getAttribute('data-toc-for');
		const article = document.getElementById(rootId);
		if(!article) return;
		const list = container.querySelector('.policy-toc__list');
		if(!list) return;
			const headings = article.querySelectorAll('h2, h3');
			if(!headings.length){ container.style.display='none'; return; }
		let lastLevel = 2; const stack = [list];
			let autoIndex = 0;
			headings.forEach(h => {
			const level = +h.tagName.substring(1); if(level>3) return; // only h2/h3
			if(!h.id){
				let id = slugify(h.textContent.trim());
				let uniq = id; let i=2;
				while(document.getElementById(uniq)){ uniq = id + '-' + i++; }
				h.id = uniq;
			}
			// Anchor injection
			if(!h.querySelector('.policy-anchor')){
				const a = document.createElement('a');
				a.href = '#' + h.id; a.className = 'policy-anchor'; a.setAttribute('aria-hidden','true');
				a.style.textDecoration='none'; a.style.marginLeft='.35em'; a.textContent='§';
				h.appendChild(a);
			}
			// nesting
			if(level > lastLevel){
				const newOl = document.createElement('ol');
				stack[stack.length-1].lastElementChild && stack[stack.length-1].lastElementChild.appendChild(newOl);
				stack.push(newOl);
			} else if(level < lastLevel){
				while(stack.length>1 && lastLevel>level){ stack.pop(); lastLevel--; }
			}
			lastLevel = level;
				const li = document.createElement('li');
				const link = document.createElement('a'); link.href = '#' + h.id;
				const rawText = h.textContent.replace(/§$/,'').trim();
				// Remove any existing leading number pattern like "10. " or "1. " to avoid duplication with TOC numbering
				const stripped = rawText.replace(/^\d+\.?\s+/, '');
				if(level === 2){ autoIndex++; }
				let displayNum = '';
				if(level === 2){ displayNum = autoIndex + '.'; }
				// Do not auto-number h3 to avoid patterns like 3.3. — leave them unnumbered
				// Put number span inside the anchor so number + text stay on one line
				if(displayNum){
					const numSpan = document.createElement('span');
					numSpan.className='policy-toc__num';
					numSpan.textContent = displayNum;
					link.appendChild(numSpan);
				} else {
					// optional placeholder for alignment when there is no number
					const ph = document.createElement('span'); ph.className='policy-toc__num'; ph.textContent=''; link.appendChild(ph);
				}
				const txt = document.createElement('span'); txt.className='policy-toc__text'; txt.textContent = stripped; link.appendChild(txt);
				li.appendChild(link);
			stack[stack.length-1].appendChild(li);
		});
	}

	function init(){
		document.querySelectorAll('.policy-toc[data-toc-for]').forEach(buildTOC);
	}
	if(document.readyState==='complete' || document.readyState==='interactive') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();

/**
 * Fixes for mini cart functionality and header layout
 * This ensures the mini-cart toggle button works correctly,
 * fixes any issues with the "Découvrez nos produits" button,
 * and ensures proper header alignment.
 */
(function() {
  function fixHeader() {
    // Find and remove the discover products button - more comprehensive approach
    document.querySelectorAll('a.button, a.link').forEach(function(btn) {
      if (!btn) return;
      var text = (btn.textContent || '').trim();
      if (text === "Découvrez nos produits" || text === "Discover our products") {
        btn.style.display = 'none';
      }
    });
    
    // Also remove any button with 'collections/all' href that isn't the cart toggle
    document.querySelectorAll('a[href*="collections/all"]').forEach(function(link) {
      if (!link.classList.contains('header__cart-toggle')) {
        link.style.display = 'none';
      }
    });

    // Make sure the cart toggle is visible and working
    var cartToggle = document.querySelector('.header__cart-toggle');
    if (cartToggle) {
      cartToggle.style.display = '';
      cartToggle.style.visibility = 'visible';
      cartToggle.style.opacity = '1';
      
      // Fix cart toggle to ensure it works correctly with cart-drawer ID
      if (cartToggle.getAttribute('aria-controls') === 'mini-cart') {
        cartToggle.setAttribute('aria-controls', 'cart-drawer');
      }

      // Add click event listener directly to the cart toggle to ensure it works
      cartToggle.addEventListener('click', function(e) {
        if (document.getElementById('cart-drawer')) {
          e.preventDefault();
          var cartDrawer = document.getElementById('cart-drawer');
          var isHidden = cartDrawer.getAttribute('aria-hidden') === 'true';
          
          // Toggle cart drawer visibility
          cartDrawer.setAttribute('aria-hidden', isHidden ? 'false' : 'true');
          cartToggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
          
          // Add/remove active class for styling
          if (isHidden) {
            cartDrawer.classList.add('is-open');
            document.body.classList.add('mini-cart-open');
          } else {
            cartDrawer.classList.remove('is-open');
            document.body.classList.remove('mini-cart-open');
          }
        }
      }, { capture: true }); // Use capture to ensure our handler runs first
    }

    // Fix header alignment
    var headerInner = document.querySelector('.header__inner');
    if (headerInner) {
      // Apply flexbox layout for proper alignment
      headerInner.style.display = 'flex';
      headerInner.style.alignItems = 'center';
      headerInner.style.justifyContent = 'space-between';
      headerInner.style.width = '100%';
      
      // Ensure action list is properly displayed
      var actionList = headerInner.querySelector('.header__action-list');
      if (actionList) {
        actionList.style.display = 'flex';
        actionList.style.alignItems = 'center';
        actionList.style.marginLeft = 'auto';
      }
      
      // Fix desktop nav display
      var desktopNav = headerInner.querySelector('.header__desktop-nav');
      if (desktopNav) {
        desktopNav.style.display = '';
        desktopNav.style.visibility = 'visible';
        desktopNav.style.flex = '1';
        desktopNav.style.marginLeft = '40px';
        desktopNav.style.marginRight = '20px';
      }
      
      // Add CSS to ensure no unwanted elements appear
      var style = document.createElement('style');
      style.textContent = `
        .header__inner > a[href*="collections/all"]:not(.header__cart-toggle) { 
          display: none !important; 
        }
        .header__inner { 
          display: flex !important; 
          align-items: center !important;
          justify-content: space-between !important;
          width: 100% !important;
        }
        .header__action-list {
          display: flex !important;
          align-items: center !important;
          margin-left: auto !important;
        }
        .header__desktop-nav {
          flex: 1 !important;
          margin-left: 40px !important;
          margin-right: 20px !important;
        }
        #cart-drawer[aria-hidden="false"] {
          visibility: visible;
          opacity: 1;
          transform: translateX(0);
        }
      `;
      document.head.appendChild(style);
    }
    
    // Fix mini-cart toggle interaction in theme.js
    if (window.theme) {
      // Always patch the miniCartElement to point to our cart-drawer
      var setupThemeCartIntegration = function() {
        // Find the cart drawer element
        var cartDrawerElement = document.getElementById('cart-drawer');
        if (!cartDrawerElement) return;
        
        // Store original element if needed for future reference
        if (!window.theme._originalMiniCartElement && window.theme.miniCartElement) {
          window.theme._originalMiniCartElement = window.theme.miniCartElement;
        }
        
        // Patch theme's miniCartElement reference
        window.theme.miniCartElement = cartDrawerElement;
        
        // Make sure the cart drawer also has the mini-cart class that theme.js expects
        if (!cartDrawerElement.classList.contains('mini-cart')) {
          cartDrawerElement.classList.add('mini-cart');
        }
        
        // Ensure proper content structure inside the cart drawer
        var contentWrapper = cartDrawerElement.querySelector('.cart-drawer__container');
        if (contentWrapper && !contentWrapper.classList.contains('mini-cart__content-wrapper')) {
          contentWrapper.classList.add('mini-cart__content-wrapper');
        }
        
        // Patch theme's toggle function if it exists
        if (typeof window.theme.Header === 'object' && window.theme.Header._toggleMiniCart) {
          var originalToggle = window.theme.Header._toggleMiniCart;
          window.theme.Header._toggleMiniCart = function(event) {
            window.theme.miniCartElement = document.getElementById('cart-drawer');
            return originalToggle.call(window.theme.Header, event);
          };
        }
      };
      
      // Run the integration immediately and on future JS loads
      setupThemeCartIntegration();
      document.addEventListener('theme:loading:end', setupThemeCartIntegration);
      
      // Also monitor if theme.js gets loaded later and patch again
      var oldDefineProperty = Object.defineProperty;
      Object.defineProperty = function(obj, prop, descriptor) {
        var result = oldDefineProperty.apply(this, arguments);
        if (obj === window && prop === 'theme') {
          setTimeout(setupThemeCartIntegration, 0);
        }
        return result;
      };
    }
  }

  // Add event to close cart drawer when clicking outside
  function setupClickOutsideHandler() {
    document.addEventListener('click', function(event) {
      var cartDrawer = document.getElementById('cart-drawer');
      var cartToggle = document.querySelector('.header__cart-toggle');
      
      if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') === 'true') {
        return;
      }
      
      // Check if click was outside the cart drawer and not on the toggle button
      if (cartDrawer && !cartDrawer.contains(event.target) && 
          cartToggle && !cartToggle.contains(event.target)) {
        // Close the cart
        cartDrawer.setAttribute('aria-hidden', 'true');
        cartDrawer.classList.remove('is-open');
        document.body.classList.remove('mini-cart-open');
        
        // Update toggle button state
        if (cartToggle) {
          cartToggle.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  // Run on load and on any DOM changes
  window.addEventListener('DOMContentLoaded', function() {
    fixHeader();
    setupClickOutsideHandler();
  });
  
  window.addEventListener('load', fixHeader);
  
  // Run immediately if document is already loaded
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    fixHeader();
    setupClickOutsideHandler();
  }
  
  // Set up mutation observer to watch for dynamic changes to the DOM
  var observer = new MutationObserver(function(mutations) {
    fixHeader();
  });
  
  // Start observing once DOM is ready
  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true });
  });
  
  // Run again after delays to catch any dynamic changes
	setTimeout(fixHeader, 300);
	setTimeout(fixHeader, 1000);
	setTimeout(fixHeader, 3000);

	// Ensure subscription variant quantity never exceeds 1 across the storefront
	function triggerSubscriptionClamp(delay){
		var normalizeFn = window.requestSubscriptionNormalization || window.scheduleSubscriptionNormalization;
		if(typeof normalizeFn === 'function'){
			normalizeFn(delay);
		}
	}
	try {
		document.addEventListener('product:added', function(){
			triggerSubscriptionClamp(150);
		});
		document.addEventListener('cart:refresh', function(){
			triggerSubscriptionClamp(200);
		});
		document.addEventListener('cart:rerendered', function(){
			triggerSubscriptionClamp(250);
		});
		window.addEventListener('pageshow', function(){
			triggerSubscriptionClamp(300);
		});
		triggerSubscriptionClamp(400);
	}catch(_e){}
})();
